import { createFileRoute } from '@tanstack/react-router'

import { Frame } from '@/components/frame'
import { PageHeader } from '@/components/page-header'
import { QuestionnairesWorkspace } from '@/components/questionnaires/questionnaires-workspace'

/** Les questionnaires au client, tous clients confondus (lot 23). */
export const Route = createFileRoute('/_app/questionnaires/')({
  component: QuestionnairesPage,
})

function QuestionnairesPage() {
  return (
    <div className="space-y-6">
      <PageHeader title="Questionnaires" documentTitle="Questionnaires" />
      <Frame>
        <QuestionnairesWorkspace />
      </Frame>
    </div>
  )
}
